import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Eye } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { api, messageErreur } from "@/lib/api";

export const ApercuBandeau = () => {
  const { apercu, quitterApercu, rechargerActif } = useTheme();
  const navigate = useNavigate();
  if (!apercu) return null;

  const activer = async () => {
    try {
      await api.post(`/themes/${apercu.id}/activer`);
      await rechargerActif();
      quitterApercu();
      toast.success(`Thème « ${apercu.nom} » activé pour tous.`);
    } catch (e) { toast.error(messageErreur(e)); }
  };
  const quitter = () => { quitterApercu(); navigate("/parametres/themes"); };

  return (
    <div data-testid="theme-preview-banner" className="at-bandeau flex items-center gap-2 px-4 md:px-8 py-2">
      <Eye size={17} className="shrink-0" />
      <p className="text-sm font-semibold flex-1 min-w-0 truncate" data-testid="theme-preview-banner-text">Aperçu du thème {apercu.nom}</p>
      <button type="button" onClick={activer} className="at-btn shrink-0 !px-4" style={{ background: "var(--micro)", color: "var(--micro-ink)" }} data-testid="theme-preview-activate">Activer</button>
      <button type="button" onClick={quitter} className="at-btn shrink-0 !px-4" style={{ background: "transparent", color: "var(--accent-ink)" }} data-testid="theme-preview-quit">Quitter</button>
    </div>
  );
};
